export const CLASS_YEARS = [0, 1, 2, 3]

export const CLASS_YEARS_LABELS = ['Senior', 'Junior', 'Sophomore', 'Freshman']
